import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {SharedPipesModule} from '@shared/shared-pipes.module';
import {ContactsModule} from '@features/contacts/contacts.module';
import {DndToggleComponent} from '@features/calls/dnd-toggle/dnd-toggle.component';
import {CallCardComponent} from '@features/calls/call-card/call-card.component';
import {ConversationComponent} from './components/conversation/conversation.component';
import {ConversationListComponent} from './components/conversation-list/conversation-list.component';
import {ManageParticipantsDialogComponent} from './components/manage-participants-dialog/manage-participants-dialog.component';
import {ForwardMessageDialogComponent} from './messenger/forward-message-dialog/forward-message-dialog.component';
import {MessageInfoDialogComponent} from './messenger/message-info-dialog/message-info-dialog.component';
import {MessengerPresenceFaceComponent} from './messenger/presence-face/messenger-presence-face.component';
import {MessengerFileCardComponent} from './messenger/file-card/messenger-file-card.component';
import {MessengerMessageCardComponent} from './messenger/message-card/messenger-message-card.component';
import {MessengerReactionPickerComponent} from './messenger/reaction-picker/messenger-reaction-picker.component';
import {MessengerVoiceBubbleComponent} from './messenger/voice-bubble/messenger-voice-bubble.component';
import {MembersTabComponent} from './components/members-tab/members-tab.component';
import {NewChatSheetComponent} from './components/new-chat-sheet/new-chat-sheet.component';
import {GroupMembersPanesComponent} from './components/group-members-panes/group-members-panes.component';

// The chat list and thread on their own (ITP-E-194-01), so the right-side Chat panel and the Messages page under
// Orbitax Meet render the same components. TaskManagerModule imports and re-exports this module, so the panel is
// unchanged; the lazy Meet shell (OrbitaxMeetShellModule) imports it directly. It must never import CoreModule, nor
// anything that does: CoreModule re-exports BrowserModule, and a lazy module that pulls it in throws NG05100
// (MEET-E-03-01). That is why the components left TaskManagerModule, which imports CoreModule.
@NgModule({
  declarations: [
    ConversationComponent,
    ConversationListComponent,
    ManageParticipantsDialogComponent,
    ForwardMessageDialogComponent,
    MessageInfoDialogComponent,
    MembersTabComponent,
    NewChatSheetComponent,
    GroupMembersPanesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedPipesModule,
    ContactsModule,
    DndToggleComponent,
    CallCardComponent,
    MessengerPresenceFaceComponent,
    MessengerFileCardComponent,
    MessengerMessageCardComponent,
    MessengerReactionPickerComponent,
    // ITP-E-249-01 (B-25): a voice message in the thread.
    MessengerVoiceBubbleComponent
  ],
  exports: [
    ConversationComponent,
    ConversationListComponent,
    ManageParticipantsDialogComponent
  ]
})
export class ChatViewsModule {
}
